<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<crumbs type="2" height="53px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="timBox">
				<div class="timBoxTit">
					<div class="timBoxTitInfo">
						<div class="timBoxTitInfoImg">
							<img :src="$imgFn('试卷', 2)" alt="" />
						</div>
						<div class="timBoxTitInfoCont">
							<div class="timBoxTitInfoTit">
								<h2>同类题推荐</h2>
								<div class="zzAdminItemJjI zzAdminItemJjI1" :title="sxData.testCenter">
									{{ sxData.testCenter }}
								</div>
								<!-- <div class="zzAdminItemJjI zzAdminItemJjI3">
					数字连读
				  </div> -->
								<div class="timBoxTitInfoZt">总计 {{ total }} 套</div>
							</div>
							<div class="timBoxTitInfoP">
								<p>难 易 度：</p>
								<span :class="sxData.difficultyScore == '' ? 'active' : ''" @click="tabFn1('')">全部</span>
								<span :class="sxData.difficultyScore == '0.1' ? 'active' : ''" @click="tabFn1('0.1')">0.1</span>
								<span :class="sxData.difficultyScore == '0.2' ? 'active' : ''" @click="tabFn1('0.2')">0.2</span>
								<span :class="sxData.difficultyScore == '0.3' ? 'active' : ''" @click="tabFn1('0.3')">0.3</span>
								<span :class="sxData.difficultyScore == '0.4' ? 'active' : ''" @click="tabFn1('0.4')">0.4</span>
								<span :class="sxData.difficultyScore == '0.5' ? 'active' : ''" @click="tabFn1('0.5')">0.5</span>
								<span :class="sxData.difficultyScore == '0.6' ? 'active' : ''" @click="tabFn1('0.6')">0.6</span>
								<span :class="sxData.difficultyScore == '0.7' ? 'active' : ''" @click="tabFn1('0.7')">0.7</span>
								<span :class="sxData.difficultyScore == '0.8' ? 'active' : ''" @click="tabFn1('0.8')">0.8</span>
								<span :class="sxData.difficultyScore == '0.9' ? 'active' : ''" @click="tabFn1('0.9')">0.9</span>
								<span :class="sxData.difficultyScore == '1' ? 'active' : ''" @click="tabFn1('1')">1</span>
								<span class="tip">( 系数越小越困难，系数越大越简单 ）</span>
							</div>
							<div class="timBoxTitInfoP">
								<p>材料类型：</p>
								<span :class="sxData.materialForm == '' ? 'active' : ''" @click="tabFn2('')">全部</span>
								<span :class="sxData.materialForm == 'Q' ? 'active' : ''" @click="tabFn2('Q')">对话</span>
								<span :class="sxData.materialForm == 'D' ? 'active' : ''" @click="tabFn2('D')">独白</span>
							</div>
							<div class="timBoxTitInfoP">
								<p>题型统计：</p>
								<span :class="sxData.questionTypeStructure == '' ? 'active' : ''" @click="tabFn3('')">全部</span>
								<span :class="sxData.questionTypeStructure == '1Q' ? 'active' : ''" @click="tabFn3('1Q')">一文一答</span>
								<span :class="sxData.questionTypeStructure == '2Q' ? 'active' : ''" @click="tabFn3('2Q')">一文两答</span>
								<span :class="sxData.questionTypeStructure == '3Q' ? 'active' : ''" @click="tabFn3('3Q')">一文三答</span>
								<span :class="sxData.questionTypeStructure == '4Q' ? 'active' : ''" @click="tabFn3('4Q')">一文四答</span>
							</div>
						</div>
						<div class="timBoxTitInfoRig supHove3">
							<div class="timBoxTitInfoBtn timBoxTitInfoBtn1" @click="fullBtn">
								<img src="@/assets/img/qp.svg" alt="" />
								<span>全屏解析</span>
							</div>
						</div>
					</div>
					<div class="timBoxEw">
						<div class="timBoxEwTit">同类题测评计数</div>
						<div class="timBoxEwCont">
							<div class="timBoxEwItem">
								<h2>{{ tjData.total || 0 }}</h2>
								<p>答题总数</p>
							</div>
							<div class="timBoxEwItem timBoxEwItem1">
								<h2>{{ tjData.correct || 0 }}</h2>
								<p>正确总数</p>
							</div>
							<div class="timBoxEwItem timBoxEwItem2">
								<h2>{{ tjData.error || 0 }}</h2>
								<p>错误总数</p>
							</div>
						</div>
					</div>
				</div>
				<div class="timCont">
					<div class="kaoshiCont">
						<div class="kaoshiFixYs">
							<div class="kaoshiFixYsCont">
								{{ bsData.slice(bsIns, bsIns + 1)[0] + 'x' }}
							</div>
							<div class="kaoshiFixP">
								<img src="@/assets/img/x.png" @click="yusFn('-')" class="img1" alt="" />
								<p>语速调节</p>
								<img src="@/assets/img/s.svg" @click="yusFn('+')" class="img2" alt="" />
							</div>
						</div>
						<div class="kaoshiTm" v-for="(it, is) in perData" :key="is">
							<div class="kaoshiTnum">
								试题编号：{{ it.number }}
								<span>考点：{{ it.testCenterName }}</span>
							</div>
							<h4 v-if="it.yydSmallQuestionList.length > 1">
								听材料回答以下{{ thData.split(',')[it.yydSmallQuestionList.length - 1] }}小题
								<jting-button @btns="jtBtns(it)" @qkFn="qkFn" :ref="'jting'" />
							</h4>
							<div class="kaoshiXtim" v-for="(item, index) in it.yydSmallQuestionList" :key="index">
								<div class="kaoshiT">
									<div class="kaoshiWt">
										<div class="kaoshiDa">
											<i>(</i>
											<span>{{ item.vals }}</span>
											<i>)</i>
										</div>
										{{ item.title }}
										<!-- <div class="kaoshiWtBtn supHove3" @click="jtBtns(it)">
					  <img src="@/assets/img/形状.png" alt="">
					  精听
					</div> -->
										<jting-button v-if="it.yydSmallQuestionList.length == 1" @btns="jtBtns(it)" @qkFn="qkFn" :ref="'jting'" />
									</div>
									<div class="kaoshiXx">
										<p v-for="(a, b) in item.yydSmallQuestionOptionList" :key="b" @click="funs(item, it, a)">{{ a.number }}、{{ a.content }}</p>
									</div>
								</div>
							</div>
							<div class="dajbox" :class="it.daFlag ? 'cwActive' : ''" v-if="it.kgFlag">
								<div class="lookJx" @click="it.jxFlag = !it.jxFlag">
									查看解析
									<i class="el-icon-caret-bottom" v-if="!it.jxFlag"></i>
									<i class="el-icon-caret-top" v-if="it.jxFlag"></i>
								</div>
								<div class="lookDaBox" v-show="it.jxFlag && it.kgFlag">
									<div class="lookDaTit">正确答案：{{ it.yydSmallQuestionList.map((item) => item.answer).join(' ') }}</div>
									<div class="lookDaCont">
										<p class="lookDaContP" v-html="$removeSty(it.originalContent)"></p>
									</div>
								</div>
							</div>
						</div>
						<fenye v-if="perData.length && !lzFlag" :total="total" ref="fybox" @dataFn="perList" />
						<div style="padding: 100px 0" v-if="!perData.length">
							<el-empty description="暂无试题"></el-empty>
						</div>
					</div>
				</div>
			</div>
		</div>
		<fullScreen :tmDec="tmDec" :lzFlag="1" v-if="fullFlag" @gbFn="fullFlag = false" ref="fullBoxs" />
		<!-- <foot /> -->
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import crumbs from '@/components/hearder/crumbs';
import userHeader from '@/components/hearder/userHeader';
import fenye from '@/components/pubComponents/fenye';
import axios from 'axios';
import fullScreen from '@/page/user/fullScreen.vue';

export default {
	name: 'yulanSt',
	data() {
		return {
			type: 1, // 1文章 2视频 3音乐 4电影
			txt: '',
			fullscreenLoading: false,
			thData: '一,两,三,四,五,六,七,八,九,十,十一,十二,十三,十四,十五',
			lzFlag: false,
			stData: [],
			tjData: {},
			bsIns: 2,
			bsData: ['0.5', '0.75', '1', '1.25', '1.5', '1.75'],
			a: ['个人中心'],
			stFlag: 1,
			total: 0,
			perData: [],
			sxData: {
				materialForm: null,
				questionTypeStructure: null,
				difficultyScore: null,
				sortComprehensive: '',
				testCenter: '',
				sort: 1
			},
			fullFlag: false,
			tmDec: '',
			fullscreen: '',
			testCenterName: ''
		};
	},
	components: {
		userHeader,
		crumbs,
		fullScreen,
		fenye,
		foot
	},
	methods: {
		funs(item, it, a) {
			item.vals = a.number;
			if (it.yydSmallQuestionList.filter((r) => r.vals).length == it.yydSmallQuestionList.length) {
				let is = 0;
				it.yydSmallQuestionList.forEach((item) => {
					if (item.vals != item.answer) {
						is = 1;
					}
				});
				if (is) {
					it.daFlag = true;
				} else {
					it.daFlag = false;
				}
				it.kgFlag = true;
			}
			this.gshFn();
		},
		gshFn() {
			console.log(this.perData, 9998888);
			let dnum = 0;
			let cnum = 0;
			for (let item of this.perData) {
				let is = 1;
				for (let it of item.yydSmallQuestionList) {
					if (!it.vals) {
						is = 0;
					}
				}
				if (is) {
					for (let it of item.yydSmallQuestionList) {
						if (it.vals) {
							if (it.answer == it.vals) {
								dnum += 1;
							} else {
								cnum += 1;
							}
						}
					}
				}
			}

			this.tjData.total = dnum + cnum;
			this.tjData.correct = dnum;
			this.tjData.error = cnum;
		},
		qkFn() {
			console.log(this.$refs['jting'].length, 9999);
			if (this.$refs['jting'].length) {
				this.$refs['jting'].forEach((item) => {
					item.btnFlag = false;
					item.bfFlag = true;
				});
			} else {
				this.$refs['jting'].btnFlag = false;
				this.$refs['jting'].bfFlag = true;
			}
		},
		jtBtns(item) {
			console.log(item, 7777);
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: item.recordingFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								this.$audio.init(URL.createObjectURL(blob), (r) => {});
								this.$nextTick((r) => {
									this.$audio.play();
								});
							}
						});
					}
				});
		},
		tabFn1(val) {
			this.sxData.difficultyScore = val;
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		tabFn2(val) {
			this.sxData.materialForm = val;
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		tabFn3(val) {
			this.sxData.questionTypeStructure = val;
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		yusFn(type) {
			if (type == '-') {
				if (this.bsIns == 0) return;
				this.bsIns--;
			} else {
				if (this.bsIns == 5) return;
				this.bsIns++;
			}
			this.$audio.playbackRate(this.bsData.slice(this.bsIns, this.bsIns + 1)[0]);
		},
		daBtn(s, index, b, val) {
			// item = val
			this.$set(this.daJh[s].children[index].tms, b, val);
		},
		btnFn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './scDec',
				query: {
					type: 1,
					txt: str
				}
			});
		},
		lzFn(item) {
			let arr = [item];
			let num = 1;
			arr.forEach((item) => {
				item.audioFlag = false;
				item.jxFlag = true;
				item.kgFlag = false;
				item.daFlag = false;
				item.yydSmallQuestionList.forEach((i) => {
					i.num = num;
					i.vals = '';
					num += 1;
				});
			});
			this.tjData = {
				total: 0,
				correct: 0,
				error: 0
			};
			this.perData = arr;
			this.lzFlag = true;
		},
		fullBtn() {
			if (this.perData.length == 0) {
				this.$message({
					message: '暂无试题',
					type: 'warning'
				});
				return;
			}

			this.tmDec = JSON.stringify({
				name: this.a[this.a.length - 1],
				tabTxt: this.a[this.a.length - 1],
				yydTextbookQuestions: this.perData,
				testCenter: this.sxData.testCenter
			});
			this.fullFlag = true;
			this.$nextTick(() => {
				this.$refs['fullBoxs'].onFullScreen();
			});
			// this.$router.push({
			//   path: './fullScreen',
			//   query: {
			//     tmDec: JSON.stringify({
			//       name: this.a[this.a.length-1],
			//       tabTxt: this.a[this.a.length-1],
			//       yydTextbookQuestions: this.perData
			//     }),
			//   }
			// })
		},
		kaoBtn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './kaoshi',
				query: {
					txt: str
				}
			});
		},
		init() {
			let randomNum = Math.floor(Math.random() * 1000000);
			this.sxData.sortComprehensive = randomNum.toString().padStart(6, '0');

			this.stFn();
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		stFn() {
			// 试题篮子
			this.$http.get('api/app/yydExaminationQuestion/selectYydExaminationQuestionListBasket').then((res) => {
				console.log(res);
				if (res.code == 200) {
					this.stData = res.rows || [];
				}
			});
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			let datas = {
				...pre,
				...this.sxData
			};
			console.log(JSON.stringify(datas), 7777);
			this.fullscreenLoading = true;
			// this.$http.get(`api/app/yydExaminationQuestion/similarTopics`,{
			//   params: {
			//     ...this.sxData,
			//   }
			// }).then(res => {
			//   if(res.code == 200) {
			//     console.log(res)
			//     this.tjData = res.data
			//   }
			// })
			let surl = '';
			if (this.stFlag == 1) {
				surl = 'api/app/yydExaminationQuestion/list';
			} else {
				surl = 'api/app/yydExaminationQuestion/selectYydExaminationQuestionListBasket';
			}
			this.$http
				.get(surl, {
					params: {
						...datas,
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						console.log(res.rows, 88888);
						let num = 1;
						res.rows.forEach((item) => {
							item.audioFlag = false;
							item.jxFlag = true;
							item.kgFlag = false;
							item.daFlag = false;
							item.yydSmallQuestionList.forEach((i) => {
								i.num = num;
								i.vals = '';
								num += 1;
							});
						});
						this.tjData = {
							total: 0,
							correct: 0,
							error: 0
						};
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		}
	},
	mounted() {
		const { txt, tabFtxt, smallQuestionId, testCenterName } = this.$route.query;
		if (tabFtxt) {
			this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
		}
		if (testCenterName) {
			this.sxData.testCenter = testCenterName || '';
		}
		this.smallQuestionId = smallQuestionId || '';
		this.txt = txt || '';
		if (txt.includes('~')) {
			this.a.push(...txt?.split('~'));
		} else {
			this.a.push(txt);
		}

		this.init();
	}
};
</script>
<style lang="scss" scoped>
.timBox {
	width: 1200px;
	margin: 0 auto 10px;
	.timCont {
		display: flex;
		margin-top: 10px;
		.timContL {
			flex: 1;
			margin-right: 10px;
			.timContLB {
				background: #ffffff;
				border-radius: 6px;
				padding: 10px 17px 42px;
				h1 {
					height: 44px;
					line-height: 44px;
					color: #000000;
					font-size: 16px;
					font-weight: bold;
					padding-left: 2px;
				}
				.timContLBTm {
					margin-bottom: 20px;
					font-size: 12px;
					&:last-of-type {
						margin-bottom: 0;
					}
					.timContLBTmT {
						color: #9c9c9c;
						line-height: 2;
						margin-bottom: 12px;
					}
					.timContLBTmW {
						color: #000000;
						font-weight: bold;
						margin-bottom: 9px;
					}
					.timContLBTmD {
						line-height: 2;
						font-size: 12px;
						color: #000;
					}
				}
			}
			.timContLT {
				background: #ffffff;
				border-radius: 6px;
				margin-bottom: 10px;
				padding: 16px 19px 20px 17px;
				> p {
					display: flex;
					align-items: center;
					color: #000000;
					font-size: 12px;
					font-weight: bold;
					margin-bottom: 16px;
					span {
						margin-left: 12px;
						color: #8f9190;
						font-weight: 400;
					}
				}
			}
			.timContLTTj {
				font-size: 12px;
				color: #000;
				margin-bottom: 16px;
				h2 {
					font-weight: bold;
					margin-bottom: 6px;
				}
				p {
					font-weight: 400;
				}
			}
		}
	}
	.timBoxTit {
		display: flex;
		.timBoxTitInfo {
			flex: 1;
			margin-right: 10px;
			height: 136px;
			background: #ffffff;
			border-radius: 6px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			padding: 17px 17px 19px;
			position: relative;
			.timBoxTitInfoImg {
				width: 100px;
				height: 100px;
				margin-right: 11px;
				img {
					width: 100px;
					height: 100px;
					border-radius: 6px;
				}
			}
			.timBoxTitInfoCont {
				padding-right: 5px;
				flex: 1;
				.timBoxTitInfoFot {
					display: flex;
					align-items: center;
					font-size: 12px;
					color: #8f9190;
					.timBoxTitInfoFotItem {
						margin-right: 26px;
						display: flex;
						align-items: center;
						img {
							width: 12px;
							height: 12px;
							margin-right: 7px;
						}
					}
				}
				.timBoxTitInfoSts {
					margin-top: 10px;
					display: flex;
					align-items: center;
					font-size: 12px;
					color: #333333;
					margin-bottom: 7px;
					.timBoxTitInfoSt {
						margin-right: 21px;
						display: flex;
						align-items: center;
					}
					img {
						width: 13px;
						height: 13px;
						margin-right: 4px;
					}
				}
				.timBoxTitInfoP {
					display: flex;
					font-size: 12px;
					margin-bottom: 9px;
					&:last-of-type {
						margin-bottom: 0px;
					}
					p {
						width: 60px;
						margin-right: 18px;
					}
					span {
						margin-right: 22px;
						color: #333333;
						cursor: pointer;
					}
					.active {
						color: #1d7b3a;
					}
					.tip {
						color: #8f9190;
					}
				}
				.timBoxTitInfoTit {
					display: flex;
					align-items: center;
					margin-bottom: 10px;
					.timBoxTitInfoZt {
						position: absolute;
						font-size: 12px;
						color: #1d7b3a;
						top: 20px;
						right: 19px;
					}
					h2 {
						color: #000000;
						font-size: 16px;
						font-weight: bold;
						margin-right: 16px;
					}
					.shouc {
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;
						img {
							width: 15px;
							height: 15px;
							margin-right: 4px;
							margin-top: 2px;
						}
						span {
							font-size: 14px;
							color: #1d7b3a;
						}
					}
				}
			}
			.timBoxTitInfoRig {
				position: absolute;
				right: 21px;
				display: flex;
				bottom: 15px;
				.timBoxTitInfoBtn {
					width: 90px;
					height: 30px;
					background: #1d7b3a;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-left: 10px;
					font-size: 14px;
					color: #ffffff;
					border-radius: 6px;
					cursor: pointer;
					img {
						width: 17px;
						height: 17px;
						margin-right: 3px;
					}
				}
				.timBoxTitInfoBtn1 {
					background: #ffac3e;
				}
			}
		}
		.timBoxEw {
			width: 310px;
			height: 136px;
			background: #ffffff;
			border-radius: 6px;
			.timBoxEwTit {
				margin: 17px 0 20px;
				font-size: 18px;
				color: #000000;
				font-weight: bold;
				text-align: center;
			}
			.timBoxEwCont {
				display: flex;
				padding: 0 35px;
				justify-content: space-between;
				.timBoxEwItem {
					display: flex;
					flex-direction: column;
					align-items: center;
					h2 {
						margin-bottom: 10px;
						font-weight: bold;
						font-size: 22px;
						color: #000000;
					}
					p {
						font-size: 14px;
						color: #000000;
					}
				}
				.timBoxEwItem1 {
					h2,
					p {
						color: #23a14c;
					}
				}
				.timBoxEwItem2 {
					h2,
					p {
						color: #ee5923;
					}
				}
			}
		}
	}
}
.timContR {
	background: #fff;
	padding: 0 13px 15px;
	border-radius: 6px;
	width: 310px;
	box-sizing: border-box;
	.meiWecTit {
		height: 63px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #f8f8f8;
		font-size: 18px;
		font-weight: bold;
		justify-content: space-between;
		> img {
			width: 30px;
			height: 30px;
			margin-right: 7px;
		}
		.qbIcon {
			font-size: 14px;
			color: #ababab;
			display: flex;
			align-items: center;
			font-weight: 400;
			line-height: 1;
			cursor: pointer;
			i {
				margin-left: 6px;
			}
		}
	}
	.meiWecRBoxC {
		margin-top: 5px;
		.meiWecRCItem {
			padding: 16px 3px;
			border-bottom: 1px solid #f8f8f8;
			display: flex;
			cursor: pointer;
			.imgs {
				width: 60px;
				height: 60px;
				margin-right: 7px;
				border-radius: 6px;
			}
			.meiWecRCItemR {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: center;
				p {
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
					font-size: 14px;
					color: #000000;
					font-weight: bold;
					margin-bottom: 10px;
				}
				.meiWecRCItemRF {
					color: #8f9190;
					font-size: 12px;
					width: 196px;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
				}
			}
			&:last-of-type {
				border-bottom: none;
			}
		}
	}
}

.zzAdminItemJjI {
	padding: 0 12px;
	height: 22px;
	font-size: 12px;
	text-align: center;
	line-height: 22px;
	border-radius: 4px;
	margin-right: 6px;
	max-width: 330px;
	overflow: hidden; /* 确保超出容器的内容被裁剪 */
	white-space: nowrap; /* 确保文本在一行内显示 */
	text-overflow: ellipsis; /* 超出部分显示省略号 */
}
.zzAdminItemJjI0 {
	background: #fef7f0;
	color: #f7860f;
}
.zzAdminItemJjI1 {
	background: #fef7f0;
	color: #f7860f;
}
.zzAdminItemJjI3 {
	background: #f1f7fe;
	color: #1675e5;
}
.kaoshiCont {
	padding: 0 30px 29px;
	color: #000000;
	flex: 1;
	// margin-right: 10px;
	background: #fff;
	border-radius: 6px;
	position: relative;
	.kaoshiFixYs {
		position: -webkit-sticky; /* Safari */
		position: sticky;
		float: right;
		top: 0px;
		width: 108px;
		height: 98px;
		color: #fff;
		background: url('@/assets/img/ys.svg') 100% no-repeat;
		.kaoshiFixYsCont {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			margin-top: -4px;
		}
		.kaoshiFixP {
			position: absolute;
			bottom: 15px;
			width: 100%;
			display: flex;
			justify-content: center;
			font-size: 12px;
			align-items: center;
			p {
				margin: 0 6px;
			}
			img {
				width: 9px;
				height: 6px;
				cursor: pointer;
				margin-top: 1px;
			}
			.img1 {
				transform: rotate(90deg);
			}
			.img2 {
				transform: rotate(90deg);
			}
		}
	}

	.kaoshiTnum {
		height: 52px;
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #333333;
		border-bottom: 1px solid #f8f8f8;
		margin: 0 0 18px;
		span {
			font-size: 12px;
			margin-left: 18px;
		}
	}
	h4 {
		font-weight: bold;
		font-size: 18px;
		margin: 40px 0;
	}
	h1 {
		font-size: 28px;
		padding-top: 38px;
		margin-bottom: 25px;
		font-weight: bold;
		text-align: center;
	}
	h2 {
		font-size: 18px;
		margin-bottom: 27px;
		text-align: center;
		padding-bottom: 34px;
		border-bottom: 1px solid #f8f8f8;
	}
	.kaoshiTm {
		h3 {
			font-size: 18px;
			font-weight: bold;
			margin: 40px 0 13px;
			text-indent: 2em;
		}
		h4 {
			display: flex;
			align-items: center;
		}
		> p {
			font-size: 16px;
			line-height: 2;
			text-indent: 2em;
			margin-bottom: 38px;
		}
		.kaoshiXtim {
			.kaoshiT {
				margin-bottom: 40px;
				&:last-of-type {
					margin-bottom: 0;
				}
				.kaoshiXx {
					padding-left: 102px;

					p {
						margin-bottom: 36px;
						font-size: 18px;
						cursor: pointer;
						&:hover {
							color: #1d7b3a;
						}
					}
					.active {
						color: #1d7b3a;
					}
				}
				.kaoshiWt {
					display: flex;
					font-weight: bold;
					margin-bottom: 36px;
					.kaoshiWtBtn {
						margin-left: 19px;
						width: 63px;
						height: 26px;
						background: #1d7b3a;
						border-radius: 4px;
						color: #fff;
						font-size: 14px;
						display: flex;
						justify-content: center;
						align-items: center;
						font-weight: 400;
						cursor: pointer;
						img {
							width: 16px;
							height: 14px;
							margin-right: 6px;
						}
					}
					.kaoshiDa {
						width: 72px;
						margin-right: 30px;
						position: relative;
						display: flex;
						justify-content: space-between;
						span {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							margin-top: -2px;
						}
					}
				}
			}
		}
	}
}
.lookJx {
	color: #1d7b3a;
	cursor: pointer;
	margin: 30px 0 20px 31px;
}
.lookDaBox {
	margin-left: 31px;
	color: #1d7b3a;
	.lookDaTit {
		font-weight: bold;
		font-size: 18px;
		margin-bottom: 16px;
		color: #1d7b3a;
	}
	.lookDaCont {
		margin-bottom: 20px;
		line-height: 2;
		font-size: 16px;
		color: #1d7b3a;
		span {
			color: #1d7b3a;
		}
	}
	.lookDaBtn {
		width: 88px;
		height: 40px;
		border: 1px solid #1d7b3a;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
		color: #1d7b3a;
		cursor: pointer;
		border-radius: 6px;
	}
}
.cwActive {
	.kaoshiXx {
		p {
			color: #d33931 !important;
		}
	}
	.tips,
	.lookJx,
	.lookDaTit {
		color: #d33931 !important;
	}
	.lookDaCont {
		color: #d33931 !important;
		span {
			color: #d33931 !important;
		}
	}
}
.shitiLzDel {
	width: 78px;
	height: 30px;
	background: #ffffff;
	box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
	border: 1px solid #d8e0f0;
	font-size: 12px;
	color: #000000;
	border-radius: 4px;
	box-sizing: border-box;
	text-align: center;
	line-height: 30px;
	cursor: pointer;
}
.shitiLzDel1 {
	width: 92px;
	height: 30px;
	background: #1d7b3a;
	border: 1px solid #14652d;
	font-size: 12px;
	color: #ffffff;
	line-height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	i {
		margin-right: 2px;
	}
}
.shitiLzDelhs {
	opacity: 0.6;
	cursor: no-drop;
}
</style>
